<template>
  <div class="vipTendency">
    <div class="vipTendency-name">
      <span>会员人数趋势</span>
    </div>
    <el-radio-group v-model="radio1" size="small">
      <el-radio-button label="1">普通卡</el-radio-button>
      <el-radio-button label="2">金卡</el-radio-button>
    </el-radio-group>
    <div id="vipTendencyBox" style="width: 100%;height: 300px;"></div>
    <div class="vipTendencyHint">
      <div class="vipTendencyHint_img">
        <img src="../../../../public/img/vipImg/dataAnalyze.png" alt="">
      </div>
      <div class="vipTendencyHint_Cont">
        <p>数据分析思路</p>
        <p>通过等级会员人数趋势分析，可以观察一段时间内各个等级会员人数变化趋势。如果采取了会员招募计划，可通过数据验证招募会员活动是否有效，如果会员人数上升明显，说明招募活动取得了很好的效果。</p>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      radio1: "1"
    };
  },
  mounted() {
    this.initMapData();
  },
  methods: {
    initMapData() {
      console.log(1212);
      this.vipTendency = echarts.init(
        document.getElementById("vipTendencyBox")
      );

      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          //设置tip提示
          trigger: "axis"
        },
        grid: { // 图格配置
          left: "40px",
          right: "30px",
          bottom: "40px"
        },
        legend: {
          //设置区分（哪条线属于什么）
          data: ["累计会员数"]
        },
        color: ["#3AA1FF"], //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {
          //设置x轴
          type: "category",
          alignWithLabel: true,
          boundaryGap: false, //坐标轴两边不留白
          data: [
            "2019-1-1",
            "2019-2-1",
            "2019-3-1",
            "2019-4-1",
            "2019-5-1",
            "2019-6-1",
            "2019-7-1"
          ],
          name: "", //X轴 name
          nameTextStyle: {
            //坐标轴名称的文字样式
            color: "#3AA1FF",
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {
            //坐标轴轴线相关设置。
            lineStyle: {
              color: "#3AA1FF"
            }
          }
        },
        yAxis: {
          name: "",
          nameTextStyle: {
            color: "#3AA1FF",
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: "#3AA1FF"
            }
          },
          type: "value"
        },
        series: [
          {
            name: "累计会员数",
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "line",
            lineStyle: {
              normal: {
                color: "#3AA1FF"
              }
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.vipTendency.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.vipTendency {
  padding: 16px;
  background: #fff;
  margin-bottom: 14px;

  .vipTendency-name {
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    height: 24px;
    margin-bottom: 20px;
  }
  .vipTendencyHint {
    padding: 16px;
    display: flex;
    background: #f7f8fa;
    .vipTendencyHint_img {
      width: 30px;
      img {
        width: 100%;
      }
    }
    .vipTendencyHint_Cont {
      margin-left: 20px;
      height: 48px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
    }
  }
}
</style>
